import { useFormatter } from 'next-intl';
import { FC } from 'react';
import Cork from 'src/components/icons/Cork';

interface Props {
  loyaltyPoints: number;
  // Add proper types (es. numberSize: "xs" | "sm" ecc.)
  corkSize?: string;
  corkColor?: string;
  numberSize?: string;
  numberColor?: string;
  numberWeight?: string;
}

const Corks: FC<Props> = (
  props: Props = {
    corkSize: '5',
    corkColor: 'secondary',
    numberSize: '2xl',
    numberColor: 'secondary',
    numberWeight: 'bold',
    loyaltyPoints: 0,
  },
) => {
  const corkClasses = [
    `text-${props.corkColor}`,
    `h-${props.corkSize}`,
    `w-${props.corkSize}`,
  ].join(' ');

  const numberClasses = [
    'mr-1',
    `text-${props.numberColor}`,
    `font-${props.numberWeight}`,
    `text-${props.numberSize}`,
  ].join(' ');

  const formatter = useFormatter();

  return (
    <div className="inline-flex items-center">
      <span className={numberClasses}>
        {formatter.number(props.loyaltyPoints, { localeMatcher: 'best fit' })}
      </span>
      <Cork className={corkClasses} />
    </div>
  );
};

export default Corks;
